require('./bootstrap');

// Delete Swal Dialog
(() => {
    window.msw = window.msw || {};
    window.msw.confirmDelete = function (table, $element) {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: ["Cancel", "Delete"],
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    let data = table.row($element.parents('tr')).data();
                    let url = $element.data('href');
                    axios.delete(url)
                        .then((response) => {
                            table.row($element.parents('tr'))
                                .remove()
                                .draw();

                            swal("Your data has been deleted!", {
                                icon: "success",
                            });
                        })
                        .catch((error) => {
                            console.log(error);
                            swal("En error occured!");
                        });


                } else {
                    // swal("Canceled!");
                }
            });
    };
})();
